var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 18.857a6.857 6.857 0 1 0 0-13.714a6.857 6.857 0 0 0 0 13.714m1.294-3.621V10.34l-4.55 5.31a.65.65 0 0 1-.42.206a.58.58 0 0 1-.61-.574v-.017c0-.133.052-.266.142-.373l5.571-6.527a.66.66 0 0 1 .498-.223a.64.64 0 0 1 .647.63v6.463a.63.63 0 0 1-.643.621a.63.63 0 0 1-.635-.621"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioz);
export default __webpack_public_path__ + "static/media/aioz.53de842fbb8c2bcf20acf28581d87ff1.svg";
export { ForwardRef as ReactComponent };